import { render, staticRenderFns } from "./ClientsTable.vue?vue&type=template&id=6e899577&scoped=true"
import script from "./ClientsTable.vue?vue&type=script&lang=js"
export * from "./ClientsTable.vue?vue&type=script&lang=js"
import style0 from "./ClientsTable.vue?vue&type=style&index=0&id=6e899577&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e899577",
  null
  
)

export default component.exports